import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout'
Vue.use(Router)

const router = new Router({
  mode: 'history', //去掉#号
  linkActiveClass: 'aa',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('./views/login')
    },
    {
      path: '/Home',
      name: 'Home',
      component: Layout,
      meta: {
        requireAuth: false   // 判断是否需要登录
      },
      children: [
        { // 促销统计
          path: '/stat',
          name: 'stat',
          component: () => import(`./views/statPage`)
        },
        { // 实时预览页面
          path: '/prev',
          name: 'prev',
          component: () => import(`./views/prev`)
        }
      ]
    },
    // 学生端路由
    {
      path: '/student',
      name: 'student',
      component: Layout,
      meta: {
        requireAuth: true,
        role: 'student'
      },
      children: [
        {
          path: '/student/dashboard',
          name: 'student-dashboard',
          component: () => import('./views/student/dashboard'),
          meta: { title: '学生仪表板' }
        },
        {
          path: '/student/error-book',
          name: 'student-error-book',
          component: () => import('./views/student/error-book'),
          meta: { title: '错题本' }
        },
        {
          path: '/student/planning',
          name: 'student-planning',
          component: () => import('./views/student/study-planning'),
          meta: { title: '学习规划' }
        },
        {
          path: '/student/analysis',
          name: 'student-analysis',
          component: () => import('./views/student/analysis'),
          meta: { title: '学习分析' }
        },
        {
          path: '/student/practice',
          name: 'student-practice',
          component: () => import('./views/student/practice'),
          meta: { title: '专项练习' }
        },
        {
          path: '/student/practice/:errorId',
          name: 'student-practice-error',
          component: () => import('./views/student/practice-error'),
          meta: { title: '错题练习' }
        },
        {
          path: '/student/real-time-answers',
          name: 'student-print',
          component: () => import('./views/student/real-time-answers'),
          meta: { title: '打印中心' }
        },
        {
          path: '/student/error-detail/:id',
          name: 'student-error-detail',
          component: () => import('./views/student/error-detail'),
          meta: { title: '错题详情' }
        },
        {
          path: '/student/plan-detail/:id',
          name: 'student-plan-detail',
          component: () => import('./views/student/plan-detail'),
          meta: { title: '计划详情' }
        },
        {
          path: '/student/profile',
          name: 'student-profile',
          component: () => import('./views/common/profile'),
          meta: { title: '个人中心' }
        }
      ]
    },
    // 教师端路由
    {
      path: '/teacher',
      name: 'teacher',
      component: Layout,
      meta: {
        requireAuth: true,
        role: 'teacher'
      },
      children: [
        {
          path: '/teacher/dashboard',
          name: 'teacher-dashboard',
          component: () => import('./views/teacher/dashboard'),
          meta: { title: '教师工作台' }
        },
        {
          path: '/teacher/errors',
          name: 'teacher-errors',
          component: () => import('./views/teacher/errors'),
          meta: { title: '班级错题' }
        },
        {
          path: '/teacher/error-detail/:id',
          name: 'teacher-error-detail',
          component: () => import('./views/teacher/error-detail'),
          meta: { title: '错题详情' }
        },
        {
          path: '/teacher/student-progress',
          name: 'teacher-student-progress',
          component: () => import('./views/teacher/student-progress'),
          meta: { title: '学生进度' }
        },
        {
          path: '/teacher/student-detail/:id',
          name: 'teacher-student-detail',
          component: () => import('./views/teacher/student-detail'),
          meta: { title: '学生详情' }
        },
        {
          path: '/teacher/assignments',
          name: 'teacher-assignments',
          component: () => import('./views/teacher/assignments'),
          meta: { title: '作业管理' }
        },
        {
          path: '/teacher/assignment-detail/:id',
          name: 'teacher-assignment-detail',
          component: () => import('./views/teacher/assignment-detail'),
          meta: { title: '作业详情' }
        },
        {
          path: '/teacher/reports',
          name: 'teacher-reports',
          component: () => import('./views/teacher/reports'),
          meta: { title: '学习报告' }
        },
        {
          path: '/teacher/knowledge',
          name: 'teacher-knowledge',
          component: () => import('./views/teacher/knowledge'),
          meta: { title: '知识点管理' }
        },
        {
          path: '/teacher/profile',
          name: 'teacher-profile',
          component: () => import('./views/common/profile'),
          meta: { title: '个人中心' }
        }
      ]
    },
    // 家长端路由
    {
      path: '/parent',
      name: 'parent',
      component: Layout,
      meta: {
        requireAuth: true,
        role: 'parent'
      },
      children: [
        {
          path: '/parent/dashboard',
          name: 'parent-dashboard',
          component: () => import('./views/parent/dashboard'),
          meta: { title: '家长中心' }
        },
        {
          path: '/parent/child-errors/:childId',
          name: 'parent-child-errors',
          component: () => import('./views/parent/child-errors'),
          meta: { title: '孩子错题' }
        },
        {
          path: '/parent/child-progress/:childId',
          name: 'parent-child-progress',
          component: () => import('./views/parent/child-progress'),
          meta: { title: '学习进度' }
        },
        {
          path: '/parent/error-detail/:id',
          name: 'parent-error-detail',
          component: () => import('./views/parent/error-detail'),
          meta: { title: '错题详情' }
        },
        {
          path: '/parent/reminders/:childId',
          name: 'parent-reminders',
          component: () => import('./views/parent/reminders'),
          meta: { title: '学习提醒' }
        },
        {
          path: '/parent/full-report/:childId',
          name: 'parent-full-report',
          component: () => import('./views/parent/full-report'),
          meta: { title: '完整报告' }
        },
        {
          path: '/parent/contact-teacher/:childId',
          name: 'parent-contact-teacher',
          component: () => import('./views/parent/contact-teacher'),
          meta: { title: '联系老师' }
        },
        {
          path: '/parent/profile',
          name: 'parent-profile',
          component: () => import('./views/common/profile'),
          meta: { title: '个人中心' }
        }
      ]
    }
  ]
})

export default router
